import { StrictMode, Component } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { initTheme } from './lib/theme';
initTheme();

import App from './App.jsx';

// ErrorBoundary global — un error de render ya NO deja la pantalla en blanco:
// muestra el error real (para depurar) y un boton de recargar (para el cliente).
// Nacio del incidente 20-jul-2026 (pantalla blanca sin pista del porque).
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
    this.setState({ compStack: info?.componentStack || '' });
  }
  render() {
    if (this.state.error) {
      const msg = String(this.state.error?.message || this.state.error);
      const stack = String(this.state.error?.stack || '').split('\n').slice(0, 10).join('\n')
        + '\n--- componentes ---\n'
        + String(this.state.compStack || '').split('\n').filter(Boolean).slice(0, 8).join('\n');
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F7F8FA', padding: 24, fontFamily: 'Poppins, system-ui, sans-serif' }}>
          <div style={{ maxWidth: 560, width: '100%', background: '#fff', borderRadius: 16, padding: 28, boxShadow: '0 8px 30px rgba(10,37,64,0.08)' }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>😥</div>
            <h1 style={{ fontSize: 18, fontWeight: 700, color: '#0A2540', margin: '0 0 6px' }}>Algo salió mal en la app</h1>
            <p style={{ fontSize: 13, color: '#6B7280', margin: '0 0 14px' }}>
              Recarga la página para continuar. Si vuelve a pasar, comparte este detalle con soporte:
            </p>
            <pre style={{ fontSize: 11, color: '#B91C1C', background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 8, padding: 10, whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: 180, overflow: 'auto' }}>
              {msg + '\n' + stack}
            </pre>
            <button onClick={() => window.location.reload()}
              style={{ marginTop: 14, width: '100%', padding: '12px 16px', fontSize: 14, fontWeight: 600, color: '#fff', background: '#0A2540', border: 'none', borderRadius: 10, cursor: 'pointer' }}>
              Recargar la página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

createRoot(document.getElementById('root')).render(
  // <StrictMode>
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
  // </StrictMode>,
);
